module.exports = __webpack_public_path__ + "img/Path 536.acc9898d.svg";